import "./channel-status.scss";
import React from "react";

function ChannelStatus(props) {

  /*IDLE: o canal está parado.
    CREATING: o canal está sendo criado.
    CREATE_FAILED: a criação do canal falhou.
    STARTING: o canal está sendo iniciado.
    RECOVERING: o canal está em processo de recuperação após uma falha.
    RUNNING: o canal está em execução e transmitindo o conteúdo ao vivo.
    STOPPING: o canal está em processo de desligamento.
    DELETING: o canal está sendo excluído.
    DELETED: o canal foi excluído.*/

  const { status = `` } = props;
  let iconColor = `#8E8C99`;
  switch (status) {
    case `RUNNING`:
      iconColor = `#44CD45`;
      break;
    case `STARTING`:
      iconColor = `#FA9B03`;
      break;
    case `IDLE`:
      iconColor = `#8E8C99`;
      break;
    case `STOPPING`:
      iconColor = `#8E8C99`;
      break;
  }

  return (
    <div className="channel-card-status">
      <div className={`status-icon status-icon-${status?.toLowerCase()}`} style={{ backgroundColor: iconColor }} />
      <span className="status-name">{status}</span>
    </div>
  );
}

export default ChannelStatus;
